import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'cancel-button',
  template: `
    <button
      pButton
      type="button"
      [class]="'atlas-btn ' + styleClass"
      [icon]="icon"
      [label]="label || ('common.cancel' | translate | uppercase)"
      [disabled]="disabled"
      [attr.data-cy]="dataCy"
      (click)="onClick.emit($event)">
    </button>
  `
})
export class CancelButtonComponent {
  @Input('data-cy') dataCy: string;

  @Input() label: string = '';
  @Input() icon: string = 'pi pi-ban';
  @Input() styleClass: string = 'atlas-btn-default atlas-btn-secondary tall';
  @Input() disabled: boolean = false;

  @Output() onClick = new EventEmitter<any>();
}
